module.exports = __webpack_public_path__ + "static/media/aspas.6d5f4e19.svg";